<template>
  <div class="pa-5">
    <!--タイトル(事例)-->
    <span class="subHead">
    {{ title }}
    </span>
    <v-icon
    class="mb-2"
    color="blue-grey darken-2">
      {{ icon }}
    </v-icon>
    <!--事例-->
    <v-card
    v-for="(list, i) in lists"
    :key="i"
    class="pa-3 ma-3 mb-"
    elevation="5">
    <div class="pt-3">
    <!--タイトル-->
      <v-icon color="blue darken-4">
        {{ listIcon }}
      </v-icon>
      <span id="listTitle">
      {{ list.title }}
      </span>

      <!--内容-->
      <v-list
      two-line
      class="pa-5">
        <v-list-item
        v-for="(content, i) in list.contents"
        :key="i">

          <v-list-item-content>
            <v-list-item-title>
              <v-icon>
                {{ content.icon }}
              </v-icon>
              {{ content.head }}
            </v-list-item-title>
            <p class="mnt-cnt" v-html="formatDescription(content.description)" />
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>
    </v-card>
  </div>
</template>

<style>
#listTitle {
  font-size: 19px;
  border-bottom: solid #778899 5px;
}

.mnt-cnt li {
  margin-bottom: 5px;
}
</style>

<script>
export default {
  data () {
    return {
      // タイトル
      title: 'システム内容及び費用',
      // タイトル横のアイコン
      icon: 'mdi-file-document-outline',
      // 見出しのアイコン
      listIcon: 'mdi-cogs',
      // リスト
      lists: [
        {
          title: 'システム内容について',
          contents: [
            {
              icon: 'mdi-home-city',
              head: '対応可能なシステム',
              description: 'Web アプリケーション、フォームアプリ、スマートフォンアプリ'
            },
            {
              icon: 'mdi-laptop',
              head: '対応可能な言語',
              description: 'java　Python　.NET　C++　PHP'
            },
            {
              icon: 'mdi-laptop',
              head: '実例',
              description: '<ul><li>Webアプリケーション、アプリからなるクラウドシステム</li><li>システム規模: 40人月程度</li><li>保守内容<ol><li>Webアプリケーション、Rest API、モバイル向けアプリケーションのソース解析によるトラブルシューティング</li><li>データベースのデータ解析によるトラブルシューティング</li><li>客先毎の軽微なカスタマイズ</li></ol></li><li>費用: 月額 80,000円\n※軽減税率、インヴォイス対応、客先毎のカスタマイズ等は別途対応</li></ul>'
            }
          ]
        }
      ]
    }
  },
  methods: {
    formatDescription (text) {
      if (!text) return ''
      return text.replace(/\n/g, '<br>')
    }
  }
}

</script>
